import script from "./widgetNotice.vue?vue&type=script&lang=js"
export * from "./widgetNotice.vue?vue&type=script&lang=js"

import "./widgetNotice.vue?vue&type=style&index=0&id=8a8bc8a8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a8bc8a8"],['__file',"src/components/widgets/widgetNotice.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8a8bc8a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8a8bc8a8', __exports__)) {
    api.reload('8a8bc8a8', __exports__)
  }
  
}


export default __exports__